/* co-edge-fade — instant, fixed-width edge fades for horizontal scrollers. Opt in by putting
   data-co-edge-fade on the scroller (e.g. a <scroll-hint>).

   Replaces ScrollHint's default mask on that element: ScrollHint's fades are ~10% wide and GROW
   proportionally with the scroll position; these are a fixed width (--co-edge-fade-w, default 10%)
   and switch on/off INSTANTLY by position — fade right at the start, both edges mid-scroll, fade
   left at the end, none when there's no overflow. The state classes' mask rules live in
   co-styles-global.css and out-rank ScrollHint's inline mask writes via !important.

   A ResizeObserver + childList MutationObserver re-evaluate when the scroller resizes or its content
   arrives asynchronously (e.g. loaded product recommendations). Rebinds on editor section re-render. */
(function () {
  if (window.__coEdgeFade) return;
  window.__coEdgeFade = true;

  function bind(el) {
    if (el.__coFadeBound) return;
    el.__coFadeBound = true;

    var raf = null;
    var update = function () {
      var max = el.scrollWidth - el.clientWidth;
      var x = el.scrollLeft;
      el.classList.remove('co-fade-right', 'co-fade-both', 'co-fade-left');
      if (max <= 2) return; // no overflow — no fade
      if (x <= 2) el.classList.add('co-fade-right');
      else if (x >= max - 2) el.classList.add('co-fade-left');
      else el.classList.add('co-fade-both');
    };
    var schedule = function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; update(); });
    };

    el.addEventListener('scroll', schedule, { passive: true });
    new ResizeObserver(schedule).observe(el);
    new MutationObserver(schedule).observe(el, { childList: true, subtree: true });
    update();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-co-edge-fade]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // Scrollers that arrive AFTER load (e.g. the recommendations track — product-recommendations.js
  // fetches and swaps its markup in) would otherwise never bind and fall back to ScrollHint's
  // scroll-proportional mask. Watch the document for added [data-co-edge-fade] elements and bind
  // them; init() is idempotent (per-element guard), and the scan is rAF-throttled.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      init();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
